import image01 from "../assets/t-image2.jpg";
import image02 from "../assets/t-image1.jpg";
import image03 from "../assets/t-image3.jpg";

export const feedbackData = [
  {
    image: image01,
    review:
      "Ser campeão Teen de Men's Physique foi a realização de um sonho, e eu não poderia ter feito isso sem o trabalho que Lucas realizou!",
    name: "DAVI FREITAS",
    status: "CAMPEÃO TEEN - MEN'S",
  },
  {
    image: image02,
    review:
      "Preparar-me para minha primeira competição tem sido muito mais fácil, graças à orientação e ao suporte do meu coach",
    name: "BRUNO CALDEIRA",
    status: "ATLETA MEN'S",
  },
  {
    image: image03,
    review:
      "Como atleta de jiu-jitsu, sinto-me mais forte e exlposivo nas minhas lutas, tudo graças ao plano de treino personalizado que recebi!",
    name: "Eduardo Cavalvante",
    status: "ATLETA DE JIU-JITSU",
  },
];
